'use client'

import ArrowForward from '@/app/_components/Icon/ArrowForward'
import LicensorImg from '@/app/_components/OnBoarding/Steps/creator_type.svg'
import LicenseeImg from '@/app/_components/OnBoarding/Steps/user_type.svg'
import { cn } from '@/app/utils'
import { useI18n } from '@/locales/client'
import Image from 'next/image'

type Props = {
  type: 'user' | 'creator' | null
  setType: (type: 'user' | 'creator' | null) => void
}

export default function Step1({ type, setType }: Props) {
  const t = useI18n()
  return (
    <div
      className={cn(
        'flex flex-col items-center gap-20 p-16 transition-all duration-700 ease-in-out lg:gap-12 lg:p-0',
        {
          'pointer-events-none absolute translate-x-[-100%] opacity-0 lg:translate-x-10':
            !!type,
          'pointer-events-auto relative translate-x-0 opacity-100': !type,
        },
      )}>
      <div
        className={
          'font-500 h-106 text-center text-24 text-text-subtlest lg:text-32'
        }>
        {t('onboarding.step1.title1')} <br />
        <span
          className={
            'c-h5 border-b-3 border-b-butterscotch text-text-inverse lg:c-h4'
          }>
          {t('onboarding.step1.title2')}
        </span>
        {t('onboarding.step1.title3')}
      </div>
      <div className={'flex flex-col gap-12'}>
        <TypeButton
          label={t('onboarding.step1.creatorBtnText')}
          image={LicensorImg}
          onClick={() => setType('creator')}
        />
        <TypeButton
          label={t('onboarding.step1.licenseeBtnText')}
          image={LicenseeImg}
          onClick={() => setType('user')}
        />
      </div>
    </div>
  )
}

function TypeButton({
  label,
  image,
  onClick,
}: {
  label: string
  image: any
  onClick: () => void
}) {
  return (
    <div
      aria-hidden
      onClick={onClick}
      className={
        'hover-card-gradient group relative flex h-164 w-360 cursor-pointer flex-col items-center justify-center gap-8 rounded-16 border-1 border-white/40 bg-white/45 p-24 shadow-card-web lg:h-144 lg:w-571 lg:p-16'
      }>
      <p className={'c-h6 text-white'}>{label}</p>
      <Image src={image} width={80} height={80} alt={'alt-creator-image'} />
      <ArrowForward
        width={52}
        height={52}
        fill={'#FFFFFF'}
        className={'absolute right-30 top-50 group-hover:animate-bounce-x'}
      />
    </div>
  )
}
